import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["location", "area"]

  connect() {
    // Initialize state on page load
    this.locationTargets.forEach(locationCheckbox => {
      if (locationCheckbox.checked) {
        this.handleLocationChange(locationCheckbox)
      }
    })
  }

  toggleLocation(event) {
    this.handleLocationChange(event.target)
  }

  handleLocationChange(locationCheckbox) {
    const locationId = locationCheckbox.dataset.locationId
    const areaCheckboxes = this.areaTargets.filter(
      checkbox => checkbox.dataset.locationId === locationId
    )

    if (locationCheckbox.checked) {
      // Parent is checked: visually check and disable children, remove name attribute
      areaCheckboxes.forEach(areaCheckbox => {
        areaCheckbox.checked = true
        areaCheckbox.disabled = true
        // Store original name and remove it to prevent form submission
        areaCheckbox.dataset.originalName = areaCheckbox.name
        areaCheckbox.removeAttribute('name')
        // Make label half transparent
        const labelId = areaCheckbox.dataset.areaLabel
        if (labelId) {
          const label = document.getElementById(labelId)
          if (label) {
            label.classList.add('opacity-50')
          }
        }
      })
    } else {
      // Parent is unchecked: uncheck, enable children, restore name attribute
      areaCheckboxes.forEach(areaCheckbox => {
        areaCheckbox.checked = false
        areaCheckbox.disabled = false
        // Restore original name attribute
        if (areaCheckbox.dataset.originalName) {
          areaCheckbox.setAttribute('name', areaCheckbox.dataset.originalName)
        }
        // Remove transparency from label
        const labelId = areaCheckbox.dataset.areaLabel
        if (labelId) {
          const label = document.getElementById(labelId)
          if (label) {
            label.classList.remove('opacity-50')
          }
        }
      })
    }
  }
}
